// Whether this host, on this platform, can close its own document from the add-in.
//
// Asked at the moment of use rather than at import: the requirement sets are only
// readable after Office.onReady, and under Jest there is no Office global at all. Any
// failure to read them is "not available" -- the caller falls back to telling the user
// to close the window, which is what happened before closing existed.

/**
 * @param set The requirement set that carries the close API, e.g. "WordApi".
 * @param version The version that introduced it.
 * @param platforms `web: false` where the host documents the API as missing on the web.
 */
export function closeAvailable(set: string, version: string, platforms: { web: boolean }): boolean {
  try {
    if (!platforms.web && (Office.context.platform as unknown as string) === "OfficeOnline")
      return false;
    return Office.context.requirements.isSetSupported(set, version);
  } catch {
    return false;
  }
}
